import { useI18n } from "../context/I18nContext";

const COLUMNS = [
  { key: "not_started", labelKey: "not_started", accent: "border-zinc-400" },
  { key: "in_progress", labelKey: "in_progress", accent: "border-cs-blueprint" },
  { key: "completed", labelKey: "completed_status", accent: "border-cs-success" },
  { key: "late", labelKey: "late", accent: "border-cs-critical" },
];

function TaskCard({ task, accent }) {
  return (
    <div className={`bg-white border border-zinc-200 border-l-4 ${accent} rounded-md p-3 hover:border-zinc-300 transition-colors`} data-testid={`kanban-card-${task.task_uid}`}>
      <div className="flex items-start justify-between gap-2">
        <span className="font-mono text-[10px] text-zinc-500">{task.task_id}</span>
        {task.is_critical && <span className="text-[9px] font-mono uppercase text-cs-accent">crit</span>}
      </div>
      <div className="text-xs font-medium text-zinc-900 line-clamp-2 mt-1" title={task.name}>{task.name}</div>
      <div className="flex items-center justify-between mt-2 text-[10px] font-mono text-zinc-500">
        <span>{(task.finish || "").slice(0, 10) || "—"}</span>
        <span>{task.percent_complete || 0}%</span>
      </div>
      {task.percent_complete > 0 && (
        <div className="mt-1.5 h-1 bg-zinc-100 rounded-full overflow-hidden">
          <div className="h-full bg-cs-accent" style={{ width: `${Math.min(100, task.percent_complete)}%` }} />
        </div>
      )}
    </div>
  );
}

export default function KanbanBoard({ data }) {
  const { t } = useI18n();
  const columns = data?.columns || {};

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="kanban-board">
      {COLUMNS.map((col) => {
        const items = columns[col.key] || [];
        return (
          <div key={col.key} className="bg-zinc-50 border border-zinc-200 rounded-md flex flex-col min-h-[400px]" data-testid={`kanban-col-${col.key}`}>
            <div className="px-3 py-2.5 border-b border-zinc-200 flex items-center justify-between">
              <span className="cs-label">{t(col.labelKey)}</span>
              <span className="font-mono text-xs font-semibold text-zinc-700">{items.length}</span>
            </div>
            <div className="p-2 space-y-2 overflow-y-auto scrollbar-thin flex-1">
              {items.slice(0, 200).map((t) => (
                <TaskCard key={t.id} task={t} accent={col.accent} />
              ))}
              {items.length === 0 && <div className="text-[11px] text-zinc-400 text-center py-6">—</div>}
              {items.length > 200 && <div className="text-[10px] text-zinc-400 text-center py-2">+{items.length - 200}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
